import type {representativeContactsRouteApi} from "./-route-api";

import {tableURLStateSchema} from "@project/components/data-display/table";
import {z} from "zod";

export const representativeContactsSearchSchema = tableURLStateSchema.extend({
  includeDeleted: z.boolean().optional().default(false),
});

export type RepresentativeContactsSearch = z.output<typeof representativeContactsSearchSchema>;
export type RepresentativeContactsNavigateFn = ReturnType<
  typeof representativeContactsRouteApi.useNavigate
>;
